export type ScreenType = 'website' | 'text' | 'file' | 'drive'

export const SCREEN_TITLES: Record<ScreenType, string> = {
  website: 'Link Website',
  text: 'Paste Text',
  file: 'Upload File',
  drive: 'Google Drive',
}

export const CONTENT_CHAR_LIMIT = 16000
